import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DownloadSimple, Copy, CheckCircle, MusicNotes } from "@phosphor-icons/react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const STATUS = {
  prepared: "Pronta · se non la pubblichi tu, esce in automatico alle 21:00",
  publishing: "In pubblicazione…",
  published: "Pubblicata in automatico",
  posted_manually: "Pubblicata da te",
  skipped_manual_posted: "Hai pubblicato tu una storia oggi: nessuna pubblicazione automatica",
  failed: "Pubblicazione automatica non riuscita",
};

const STEPS = [
  "Tocca «Scarica immagine» e salvala nel rullino.",
  "Apri Instagram → + → Storia → scegli l'immagine.",
  "Tocca l'icona adesivi → «Musica» e scegli un brano (meglio strumentale, volume basso).",
  "Tocca adesivi → «Link» e incolla il link copiato qui sotto. Testo adesivo: «Scopri Otelya».",
  "Pubblica e poi tocca «L'ho pubblicata io» qui: così alle 21:00 non esce un doppione.",
];

export default function StoryToday() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/stories/today").then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => { load(); }, []);
  if (d === false || d === null) return null;
  const st = d.today;
  const copy = async () => { try { await navigator.clipboard.writeText(`https://${st.link}`); toast.success("Link copiato"); } catch { toast.error("Copia non riuscita"); } };
  const mark = async () => { await api.post(`/admin/stories/${st.id}/mark-posted`); toast.success("Segnata come pubblicata"); load(); };

  return (
    <div className="rounded-2xl border border-line bg-canvas p-5" data-testid="story-today">
      <div className="font-serif text-lg text-ink flex items-center gap-2"><MusicNotes size={18} />Storia Instagram di oggi</div>
      {!st?.image_url ? (
        <div className="text-sm text-stone mt-2" data-testid="story-today-empty">La storia di oggi viene preparata alle 9:30.</div>
      ) : (
        <div className="mt-4 flex flex-col md:flex-row gap-6">
          <img src={`${API}${st.image_url}`} alt="Storia di oggi" className="w-44 aspect-[9/16] object-cover rounded-xl border border-line" data-testid="story-today-image" />
          <div className="flex-1 space-y-3">
            <div className="text-xs uppercase tracking-widest text-stone" data-testid="story-today-status">{STATUS[st.status] || st.status}</div>
            <div className="text-ink font-medium">{st.hook}</div>
            {st.status === "prepared" && (
              <>
                <ol className="list-decimal pl-5 space-y-1 text-sm text-ink/80">{STEPS.map((s) => <li key={s}>{s}</li>)}</ol>
                <div className="flex flex-wrap gap-2">
                  <a href={`${API}${st.image_url}`} download={`storia-${st.date}.jpg`} target="_blank" rel="noreferrer">
                    <Button className="rounded-full bg-ink text-canvas hover:bg-olive" data-testid="story-download-btn"><DownloadSimple size={16} className="mr-1" />Scarica immagine</Button>
                  </a>
                  <Button variant="outline" className="rounded-full" onClick={copy} data-testid="story-copy-link-btn"><Copy size={16} className="mr-1" />Copia link adesivo</Button>
                  <Button variant="outline" className="rounded-full" onClick={mark} data-testid="story-mark-posted-btn"><CheckCircle size={16} className="mr-1" />L'ho pubblicata io</Button>
                </div>
                <div className="text-xs text-stone">Link adesivo: https://{st.link}</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
